import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Payment} from '../../models/eventRequest';
import {PaymentService} from '../../_services/payment.service';
import {ToolsService} from '../../_services/tools.service';
import {ProfileService} from '../../_services/profile.service';
//import 'rxjs/Rx';

@Component({
    selector: 'app-payment-list',
    templateUrl: './payment-list.component.html',
    styleUrls: ['./payment-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentListComponent implements OnInit {

  @Input()
  iShowPayments: boolean = false;

  @Input()
  iPagePayment: any;

  @Input()
  iPayments: Payment[] = [];

  @Input()
  iTotalPaymentDetails: any;

  @Input()
  iShowStudent = false;

  @Input()
  iIsStudent = false;

  @Input()
  iNavMobile = false;

  @Input()
  iShowUpdateBtn = true;

  @Input()
  iShowInvoiceNumber = true;

  @Input()
  iShowRefundButton = false;

  // desactiver temporairement
  isDisabled = true;

  @Output()
  iPageNumber: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  oPaymentToUpdate: EventEmitter<Payment> = new EventEmitter<Payment>();

  @Output()
  oPaymentDisabled: EventEmitter<bigint> = new EventEmitter<bigint>();

  @Output()
  oPaymentRefund: EventEmitter<Payment> = new EventEmitter<Payment>();

  @Output()
  oOpenRefundForm: EventEmitter<void> = new EventEmitter<void>();

  userRoles: string[] = [];

  constructor(private paymentService: PaymentService,
              private toolsService: ToolsService,
              private profileService: ProfileService) {
    toolsService.getUserRoles().subscribe(
      (data: any) => {
        // @ts-ignore
        this.userRoles = data;
      },
      err => {
      });
  }

  ngOnInit(): void {
  }

  getTotalRefunds(): number {
    if (!this.iPayments || this.iPayments.length === 0) {
      return 0;
    }
    return this.iPayments
      .filter(p => p.paymentType === 'REFUND')
      .reduce((total, p) => total + Number(p.amount || 0), 0);
  }

  onChangePaymentPage($event: number) {
    this.iPageNumber.emit($event)
  }

  displayUpdatePaymentPopup(p: Payment) {
    this.oPaymentToUpdate.emit(p);
  }

  displayDisabledPayment(p: bigint) {
    this.oPaymentDisabled.emit(p);
  }

  openRefundForm() {
    this.oOpenRefundForm.emit();
  }

  uploadInvoice(paymentId: bigint) {
    this.paymentService.uploadInvoice(paymentId).subscribe(
      data => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error => {
        console.log('Error downloading the file.');
        console.log(error);
      });
  }

  uploadReceipt(paymentId: bigint) {
    const service = this.iIsStudent
      ? this.profileService.uploadReceiptForStudent(paymentId)
      : this.paymentService.uploadReceipt(paymentId);

    service.subscribe(
      data => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error => {
        console.log('Error downloading the receipt.');
        console.log(error);
      });
  }

  isSuperAdmin() {
    // @ts-ignore
    return this.userRoles.includes('ROLE_SUPER_ADMIN');
  }

  isAdmin() {
    // @ts-ignore
    return this.userRoles.includes('ROLE_ADMIN');
  }

  formatInvoiceNumber(invoiceNumber: bigint): string {
    if (!invoiceNumber) {
      return '-';
    }

    // Convertir en string
    const invoiceStr = String(invoiceNumber);

    // Si le format contient un tiret (ex: "2026-0001")
    if (invoiceStr.includes('-')) {
      const parts = invoiceStr.split('-');
      if (parts.length === 2) {
        return String(parseInt(parts[1], 10));
      }
    }

    // Si le format est numérique (ex: "20260001")
    // On extrait les 4 derniers chiffres et on retire les zéros
    if (invoiceStr.length >= 8) {
      const numberPart = invoiceStr.substring(4); // Retire les 4 premiers chiffres (l'année)
      return String(parseInt(numberPart, 10));
    }

    // Si le format n'est ni l'un ni l'autre, retourner tel quel
    return invoiceStr;
  }

  formatPaymentMethod(paymentMethod: string): string {
    switch (paymentMethod) {
      case 'ESPECE':
        return 'Espèce';
      case 'CHEQUE':
        return 'Chèque';
      case 'VIREMENT':
        return 'Virement';
      case 'CB':
        return 'Carte bancaire';
      default:
        return paymentMethod;
    }
  }

  getPaymentMethodVariant(paymentMethod: string): string {
    switch (paymentMethod) {
      case 'ESPECE':
        return 'cash';
      case 'CHEQUE':
        return 'check';
      case 'VIREMENT':
        return 'transfer';
      case 'CB':
        return 'card';
      default:
        return 'default';
    }
  }

  canDownloadInvoice(payment: Payment): boolean {
    return !this.iIsStudent && !!payment.invoiceNumber && payment.paymentType !== 'REFUND';
  }

  canDownloadReceipt(payment: Payment): boolean {
    return payment.paymentType !== 'REFUND';
  }

  canShowEditBtn(p: Payment): boolean {
    // Si super admin, toujours vrai
    if (this.isSuperAdmin()) {
      return true;
    }
    // Si admin, seulement le jour du paiement
    if (this.userRoles.includes('ROLE_ADMIN')) {
      if (!p.date) { return false; }
      const today = new Date();
      const paymentDate = new Date(p.date);
      return paymentDate.getFullYear() === today.getFullYear() &&
             paymentDate.getMonth() === today.getMonth() &&
             paymentDate.getDate() === today.getDate();
    }
    // Sinon, jamais
    return false;
  }
}
